import chalk from "chalk";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import Logger from "@/lib/logger.ts";
import { isDefined } from "@/utils/types.ts";
import type { DefaultTrackingData } from "../types";

export const pushTrackingData = (data: DefaultTrackingData) => {
    if (!isDefined(window.dataLayer)) return;

    window.dataLayer.push(data);

    DiagnosticsStore.collectTrackingEvent(data);

    Logger.groupCollapsed(`[Tracking] ${chalk.cyan(data.name)}`);
    if (Logger.enabled) console.info(data);
    Logger.groupEnd();
};
